
const digest = 'c8e806f099d7e56bdc3b3a823377f40288fb4a9ea1f49854a630a2c9bd56df07';
const classes = {"removeItemWrapper":"_removeItemWrapper_1rjac_1"};
const css = `._removeItemWrapper_1rjac_1 {
  padding: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  